import React from 'react'
import YoutubeAdPreview from './YoutubeAdPreview';

const YoutubeAdsetForm = ({ dataItem, onChange }) => {
    const videoId = dataItem?.ad?.creatives?.length > 0 ? dataItem?.ad?.creatives[0]?.url : null;
    return (
        <div className='row mt-2'>
            <div className='col-8'>
                <div className="row">
                    <div className="col-6 mt-2">
                        <label htmlFor="actionHeadline" > Action Headline *  </label>
                        <input
                            type="text"
                            name="actionHeadline"
                            placeholder="Enter Action Headline"
                            className="form-control form-control-sm"
                            value={dataItem.actionHeadline}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6 mt-2">
                        <label htmlFor="actionButtonLabel" > Action Button Label *  </label>
                        <input
                            type="text"
                            name="actionButtonLabel"
                            placeholder="Enter Action Button Label"
                            className="form-control form-control-sm"
                            value={dataItem.actionButtonLabel}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-12 mt-2">
                        <label htmlFor="finalUrls">Final Urls *</label>
                        <input
                            type="text"
                            name="finalUrls"
                            placeholder="Enter comma-separated finalUrls"
                            className="form-control form-control-sm"
                            value={dataItem.finalUrls}
                            onChange={onChange}
                        />
                        <small className="form-text text-muted">Enter comma-separated final Urls</small>
                    </div>
                </div>
            </div>
            <div className='col-4'>
                <YoutubeAdPreview videoId={videoId} actionHeadline={dataItem?.actionHeadline} actionButtonLabel={dataItem?.actionButtonLabel} finalUrls={dataItem?.finalUrls ? dataItem?.finalUrls?.split(',').map(s => s.trim()).filter(Boolean) : []} />
            </div>
        </div>
    )
}

export default YoutubeAdsetForm;